import React, { Component } from 'react'

// ui
import { Col, Row } from 'antd'
import { FaComment, FaStar } from 'react-icons/fa'

// redux
import { connect } from 'react-redux'
import ReportActions from '../../../redux/report/actions'

// api
import { getUserById } from '../../../services/apis/UserAPIServices'
import moment from 'moment'

// default avatar
import { default_avatar } from '../../../redux/user/reducer'

class ReportComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            owner: {
                avatar: '',
                display_name: '',
            },
        }
    }

    componentDidMount = async () => {
        let user = await getUserById(this.props.report.owner_id)
        this.setState({ owner: user.data })
    }

    _handleClickReport = () => {
        const { report } = this.props
        this.props.setCurrentReport(report)
        this.props.showModalReportInfo()
    }

    render() {
        const { report } = this.props
        const { owner } = this.state

        let color = 'orange'
        if (report.status === 'Sent') color = 'green'

        return (
            <div
                className="ReportComponent"
                style={{
                    textAlign: 'left',
                    borderLeft: '4px solid ' + color,
                    cursor: 'pointer',
                }}
                onClick={() => this._handleClickReport()}
            >
                <div className="ReportHeadbar" style={{ display: 'block' }}>
                    <div style={{ display: 'inline-block' }}>
                        <img
                            alt="avatar"
                            src={
                                owner.avatar !== ''
                                    ? owner.avatar
                                    : default_avatar
                            }
                        />
                    </div>
                    <div
                        style={{ display: 'inline-block' }}
                        class="name_and_time"
                    >
                        <div className="display_name">{owner.display_name}</div>
                        <div className="time_create">
                            {moment(report.created_time * 1000).format(
                                'DD/MM/YYYY'
                            )}
                        </div>
                    </div>
                    <div style={{ display: 'block' }} className="title">
                        <div>{report.title}</div>
                    </div>
                </div>
                <div className="ReportAction">
                    <Row>
                        <FaComment /> {report.comments.length}
                    </Row>
                </div>
                <div className="FollowButton">
                    <div style={{ color }}>
                        {report.status === 'Sent' ? (
                            <span>Đã gửi</span>
                        ) : (
                            <span>Đã lưu nháp</span>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {
        showModalReportInfo: () => {
            dispatch(ReportActions.action.showModalReportInfo())
        },
        setCurrentReport: report => {
            dispatch(ReportActions.action.setCurrentReport(report))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReportComponent)
